import { render, staticRenderFns } from "./ResidentPaymentMethodsTab.vue?vue&type=template&id=2c4dd876&scoped=true&"
import script from "./ResidentPaymentMethodsTab.vue?vue&type=script&lang=ts&"
export * from "./ResidentPaymentMethodsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4dd876",
  null
  
)

export default component.exports